import { User } from '../types';

const NON_RESIDENT_TYPES = new Set(['HOSTEL_ADMIN', 'STAFF', 'SUPER_ADMIN']);
const NON_RESIDENT_ROLES = new Set(['HOSTEL_ADMIN', 'STAFF', 'SUPER_ADMIN']);

function normalizeRole(role: string): string {
  return String(role || '')
    .trim()
    .toUpperCase()
    .replace(/^ROLE_/, '');
}

/** True for walk-in / resident tenants only — not hostel login or staff accounts. */
export function isResidentTenant(user: User): boolean {
  const type = String(user.userType || 'TENANT').toUpperCase();
  if (NON_RESIDENT_TYPES.has(type)) return false;
  if (type !== 'TENANT') return false;
  const roles = user.roles || [];
  return !roles.some((r) => NON_RESIDENT_ROLES.has(normalizeRole(r)));
}

export function filterResidentTenants(users: User[], excludeUserId?: number | null): User[] {
  return users.filter(
    (u) => isResidentTenant(u) && (excludeUserId == null || u.id !== excludeUserId)
  );
}
